import { imageProfileGenerator } from "../../../../utils/image/imageProfileGenerator";
import { GalleryImageObject } from "../../utils/utils.ts";
import { ZoomableImage } from "./ZoomableImage";
import styles from "./GalleryImageElement.module.scss";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import { ImageElementRef } from "@/components/Galleries/components/GalleryImageElement/ImageElement/ImageElement.tsx";

type GalleryImageElementProps = {
  mediaItem: GalleryImageObject;
  isSelected: boolean;
  index: number;
  sizes?: string;
  fullscreen?: boolean;
  hasSuperZoom?: boolean;
  usePrefetching?: boolean;
  carouselGalleryInpTest?: boolean;
  ref?: React.RefObject<ImageElementRef>;
};

export const GalleryImageElement = ({
  fullscreen,
  mediaItem,
  isSelected,
  index,
  hasSuperZoom,
  sizes,
  usePrefetching,
  carouselGalleryInpTest = false,
}: GalleryImageElementProps) =>
  fullscreen ? (
    <ZoomableImage
      mediaItem={mediaItem}
      isSelected={isSelected}
      dataTestId={`carousel-image-${index}`}
      className={styles.galleryImage}
      loading={index > 0 ? "lazy" : "eager"}
      hasSuperZoom={hasSuperZoom}
      carouselGalleryInpTest={carouselGalleryInpTest}
      index={index}
    />
  ) : (
    <img
      src={formatAmplienceImageURL(mediaItem.imageUrl)}
      alt={`Product image ${index + 1}`}
      data-testid={`carousel-image-${index}`}
      className={styles["galleryImage"]}
      sizes={sizes}
      srcSet={imageProfileGenerator(mediaItem.imageUrl)}
      loading={index > 0 ? "lazy" : "eager"}
      fetchPriority={index == 0 && usePrefetching ? "high" : "auto"}
    />
  );
